import InspectionDetails from '@/components/inspections/inspection_details.vue';
import Inspections from '@/components/inspections/inspections.vue';
import IssueForm from '@/components/issues/issue_form.vue';
import IssueHistory from '@/components/issues/issue_history.vue';
import IssueList from '@/components/tasks/issue_list.vue';
import ManageRegions from '@/components/manage_regions.vue';
import ManageRegionsHme from '@/components/plants/regions/manage_regions_hme.vue';
import MonitoringPlanForm from '@/components/monitoring_plans/monitoring_plan_form.vue';
import MonitoringPlans from '@/components/monitoring_plans.vue';
import OperationDashboard from '@/components/plants/dashboard.vue';
import OperationForm from '@/components/operation_form.vue';
import OperationLayout from '@/components/operation_layout.vue';
import PlanDetails from '@/components/monitoring_plans/plan_details.vue';
import Regions from '@/components/regions.vue';
import SiteHealthReportForm from '@/components/site_health_report_form.vue';
import TaskComments from '@/components/monitoring_plans/tasks/task_comments.vue';
import TaskDetails from '@/components/monitoring_plans/tasks/task_details.vue';
import TaskLayout from '@/components/monitoring_plans/tasks/task_layout.vue';
import TaskList from '@/components/tasks/task_list.vue';
import TaskResults from '@/components/monitoring_plans/tasks/task_results.vue';
import Tasks from '@/components/tasks.vue';
import RegionsHme from '@/components/plants/regions/regions_hme.vue';
import RegionsIssue from '@/components/regions/regions_issue_view.vue';
import RegionsIssueLocation from '@/components/plants/regions/regions_issue_location.vue';
import Configurations from '@/components/plants/configuration/configuration_page.vue';
import PlantsHmeForm from '@/components/plants/operations/heavy_mobile_equipment_form.vue';
import IssueLocationPlant from '@/components/plants/location/issue_location_plant.vue';
import IssueLocationHme from '@/components/plants/location/issue_location_hme.vue';
import BulkImport from '@/components/generic/bulk/bulk_import.vue';
import only from '../only';

export default [
  {
    path: 'operations/:operationId/edit',
    name: 'editOperation',
    component: OperationForm,
    props: true,
  },
  {
    path: 'operations/new',
    name: 'newOperation',
    component: OperationForm,
    props: true,
  },
  {
    path: 'operations/:operationId',
    component: OperationLayout,
    props: only('organisationId', 'operationId'),
    children: [
      {
        path: '',
        name: 'operation',
        component: OperationDashboard,
        props: true,
      },
      {
        path: 'regions/:issueType(plant)',
        name: 'regions',
        component: Regions,
        props: true,
        children: [
          {
            path: 'inspections/:inspectionId/issues/:issueId',
            name: 'regionsIssue',
            component: RegionsIssue,
            props: true,
          },
          {
            path: 'inspections/:inspectionId/issues/:issueId/location/plant',
            name: 'issuesLocationTypePlant',
            component: RegionsIssueLocation,
            props: true,
          },
        ],
      },
      {
        path: 'regions/:issueType(heavy_mobile_equipment)',
        name: 'regionsTypeHmes',
        component: RegionsHme,
        props: true,
        children: [
          {
            path: ':heavyMobileEquipmentId',
            name: 'regionsTypeHme',
            component: RegionsHme,
            props: true,
            children: [
              {
                path: 'inspections/:inspectionId/issues/:issueId',
                name: 'regionsIssuesTypeHme',
                component: RegionsIssue,
                props: true,
              },
            ]
          },
          {
            path: 'inspections/:inspectionId/issues/:issueId/location/heavy_mobile_equipment/:heavyMobileEquipmentId',
            name: 'regionsLocationTypeHme',
            component: RegionsIssueLocation,
            props: true,
          },
        ],
      },
      {
        path: 'monitoring_plans/:scope(plans|archived_plans)',
        name: 'plans',
        component: MonitoringPlans,
        props: only('organisationId', 'operationId', 'scope'),
        children: [
          {
            path: ':planId',
            name: 'plan',
            component: PlanDetails,
            props: true,
          },
        ],
      },
      {
        path: 'plants/:scope(inspections|approved_inspections)',
        name: 'inspections',
        component: Inspections,
        props: only('organisationId', 'operationId', 'scope'),
        children: [
          {
            path: ':inspectionId',
            name: 'inspection',
            component: InspectionDetails,
            props: true,
            children: [
              {
                path: 'bulk_import',
                name: 'bulkImport',
                component: BulkImport,
                props: true,
              },
            ]
          },
        ],
      },
      {
        path: 'plants/tasks',
        component: Tasks,
        props: only('organisationId', 'operationId'),
        children: [
          {
            path: '',
            name: 'tasks',
            redirect: { name: 'tasksCategory', params: { category: 'all' } },
          },
          {
            path: ':category(all|current|past_due|completed)',
            name: 'tasksCategory',
            component: TaskList,
            props: true,
          },
          {
            path: ':category(issues_missing_tasks|resolved_issues)',
            name: 'taskIssuesCategory',
            component: IssueList,
            props: true,
          },
        ],
      },
    ],
  },
  {
    path: 'operations/:operationId/monitoring_plans/plans/:planId/edit',
    name: 'editPlan',
    component: MonitoringPlanForm,
    props: true,
  },
  {
    path: 'operations/:operationId/monitoring_plans/plans/new',
    name: 'newPlan',
    component: MonitoringPlanForm,
    props: true,
  },
  {
    path: 'operations/:operationId/monitoring_plans/plans/:planId/points/:pointId/tasks/:taskId',
    component: TaskLayout,
    props: true,
    children: [
      {
        path: '',
        name: 'task',
        component: TaskDetails,
        props: true,
      },
      {
        path: 'comments',
        name: 'taskComments',
        component: TaskComments,
        props: true,
      },
      {
        path: 'task_results',
        name: 'taskResults',
        component: TaskResults,
        props: true,
      },
    ],
  },
  {
    path: 'operations/:operationId/plants/inspections/:inspectionId/issues/:issueId',
    name: 'issue',
    component: IssueForm,
    props: true,
  },
  {
    path: 'operations/:operationId/plants/inspections/:inspectionId/issues/new',
    name: 'newIssue',
    component: IssueForm,
    props: true,
  },
  {
    path: 'operations/:operationId/plants/inspections/:inspectionId/issues/:issueId/history',
    name: 'issueHistory',
    component: IssueHistory,
    props: true,
  },
  {
    path: 'operations/:operationId/regions/edit',
    name: 'manageRegions',
    component: ManageRegions,
    props: true,
  },
  {
    path: 'operations/:operationId/heavy_mobile_equipment/:heavyMobileEquipmentId/regions/edit',
    name: 'manageRegionsHme',
    component: ManageRegionsHme,
    props: true,
  },
  {
    path: 'operations/:operationId/plants/site_health_reports/new',
    name: 'newSiteHealthReport',
    component: SiteHealthReportForm,
    props: true,
  },
  {
    path: 'operations/:operationId/plants/site_health_reports/:siteHealthReportId/edit',
    name: 'editSiteHealthReport',
    component: SiteHealthReportForm,
    props: true,
  },
  {
    path: 'operations/:operationId/configuration',
    name: 'configuration',
    component: Configurations,
    props: true,
    children: [
      {
        path: 'plant',
        name: 'configurationPlants',
        component: Configurations,
        props: true,
      },
      {
        path: 'heavy_mobile_equipment',
        name: 'configurationHme',
        component: Configurations,
        props: true,
      },
    ],
  },
  {
    path: 'operations/:operationId/heavy_mobile_equipment/new',
    name: 'newPlantsHme',
    component: PlantsHmeForm,
    props: true,
  },
  {
    path: 'operations/:operationId/heavy_mobile_equipment/:heavyMobileEquipmentId/edit',
    name: 'editPlantsHme',
    component: PlantsHmeForm,
    props: true,
  },
  {
    path: 'operations/:operationId/inspections/:inspectionId/issues/new/location/plant',
    name: 'newIssueLocationPlant',
    component: IssueLocationPlant,
    props: true,
  },
  {
    path: 'operations/:operationId/inspections/:inspectionId/issues/:issueId/location/plant',
    name: 'issueLocationPlant',
    component: IssueLocationPlant,
    props: true,
  },
  {
    path: 'operations/:operationId/inspections/:inspectionId/issues/new/location/heavy_mobile_equipment',
    name: 'newIssueLocationHmes',
    component: IssueLocationHme,
    props: true,
    children: [
      {
        path: ':heavyMobileEquipmentId',
        name: 'issueLocationHme',
        component: IssueLocationHme,
        props: true,
      },
    ],
  },
  {
    path: 'operations/:operationId/inspections/:inspectionId/issues/:issueId/location/heavy_mobile_equipment',
    name: 'issueLocationHmes',
    component: IssueLocationHme,
    props: true,
    children: [
      {
        path: ':heavyMobileEquipmentId',
        name: 'issueLocationHme',
        component: IssueLocationHme,
        props: true,
      },
    ],
  },
];
